module.exports = __webpack_public_path__ + "img/dolce-and-gabbana.0ddcf0c8.jpg";